/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendLoginRequestDto } from '../../models/backend-login-request-dto';
import { BackendLoginResponseDto } from '../../models/backend-login-response-dto';

export interface LoginAuthLoginPost$Params {
  body: BackendLoginRequestDto;
}

export function loginAuthLoginPost(
  http: HttpClient,
  rootUrl: string,
  params: LoginAuthLoginPost$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendLoginResponseDto>> {
  const rb = new RequestBuilder(rootUrl, loginAuthLoginPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendLoginResponseDto>;
    }),
  );
}

loginAuthLoginPost.PATH = '/auth/login';
